import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
export const ProductionUnitBasicInfoComponent = ({ onInnerFormChange, selectedProductionUnit, productionPlant }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'ProductionUnitInfo.Name',
                  selectedProductionUnit?.ProductionUnitInfo
                )
              }}
              type="text"
              value={selectedProductionUnit?.ProductionUnitInfo?.Name}
          />
     <InputContainer
              label="PhoneNumber"
              name="PhoneNumber"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'ProductionUnitInfo.PhoneNumber',
                  selectedProductionUnit?.ProductionUnitInfo
                )
              }}
              type="text"
              value={selectedProductionUnit?.ProductionUnitInfo?.PhoneNumber}
          />
      <InputContainer
              label="Email"
              name="Email"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'ProductionUnitInfo.Email',
                  selectedProductionUnit?.ProductionUnitInfo
                )
              }}
              type="text"
              value={selectedProductionUnit?.ProductionUnitInfo?.Email}
          />
     <InputContainer
            label="ProductionPlant"
            labelField="ProductionPlantInfo.Name"
            list={productionPlant}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'ProductionUnitInfo.ProductionPlantId',
                selectedProductionUnit?.ProductionUnitInfo
              );
            }}
            optionName='Choose ProductionPlant'
            type="select"
            value={selectedProductionUnit?.ProductionUnitInfo?.ProductionPlantId}
            valueField="ProductionPlantInfo.Id"
        />
    <div className='col-span-full'>  <InputContainer
              label="Description"
              name="Description"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'ProductionUnitInfo.Description',
                  selectedProductionUnit?.ProductionUnitInfo
                )
              }}
              type="text"
              value={selectedProductionUnit?.ProductionUnitInfo?.Description}
          />
    </div></div>
}
expandedPanel="basicInfo"
headerTitle="Basic Info"
/>
</>
)
export default ProductionUnitBasicInfoComponent;
